import { Filter } from 'features/Filters/types/Filters';

export const draftsFilterValues: Filter[] = [
  {
    key: 'mediaOwnerNames',
    label: 'Media Owner',
  },
  {
    key: 'environments',
    label: 'Environment',
  },
  {
    key: 'formatSizeNames',
    label: 'Format Size',
  },
];
